/* @flow */
import cx from 'classnames';
import FlexibleBlock from 'components/FlexibleBlock.jsx';
import ManagerItemCard from './ManagerItemCard.jsx';
import BankAccountsMenuButton from './BankAccountsMenuButton.jsx';
import ExternalAccountResource from 'entities/ExternalAccountResource';
import React from 'react';

import './styles/BankAccountsManagerItem.scss';

export default React.createClass({
  propTypes: {
    bankAccount: React.PropTypes.instanceOf(ExternalAccountResource).isRequired,
  },

  renderPrimary() {
    return (
      <div className="BankAccountsManagerItem-primary">
        Primary account
      </div>
    );
  },

  render() {
    const externalBankAccount = this.props.bankAccount.getBankAccount();
    return (
      <ManagerItemCard className={cx('BankAccountsManagerItem', this.props.className)}>
        <FlexibleBlock flex="left">
          <div>
            <div className="BankAccountsManagerItem-title">
              {externalBankAccount.getBankName()}
            </div>
            <table className="BankAccountsManagerItem-table">
              <tbody>
                <tr>
                  <td>Routing Number:</td>
                  <td>{externalBankAccount.getRoutingNumber()}</td>
                </tr>
                <tr>
                  <td>Account Number:</td>
                  <td>
                    Last four digits{' '}
                    {externalBankAccount.getAccountNumberLastFourDigits()}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div>
            {externalBankAccount.isDefaultForCurrency() && this.renderPrimary()}
            {
              !externalBankAccount.isDefaultForCurrency() &&
                <BankAccountsMenuButton bankAccount={this.props.bankAccount} />
            }
          </div>
        </FlexibleBlock>
      </ManagerItemCard>
    );
  },
});



// WEBPACK FOOTER //
// ./src/payments/components/BankAccountsManagerItem.jsx